import React from "react";
import Logo from "../../layout/Logo/index.jsx";
import User from "../../../services/user.jsx";
import i18n from "../../../services/i18n.jsx";
import Loader from "../../layout/loader.jsx";

import style from "./index.module.scss";

class ResetPasswordRequest extends React.Component {
  constructor(props) {
    super(props);
    this.reset = this.reset.bind(this);
    this.state = {
      email: "",
      loading: false,
      resetSent: false,
    };
  }

  // On component mount, add class on body
  componentDidMount() {
    document.body.classList.add("fullscreen");
  }

  // On component unmount, remove class on body
  componentWillUnmount() {
    document.body.classList.remove("fullscreen");
  }

  // User password reset
  reset(event) {
    this.setState({ loading: true });
    event.preventDefault();
    User.reset({
      email: this.state.email,
    })
      .then(() => {
        this.setState({ email: '', loading: false, resetSent: true });
      })
      .catch((err) => {
        this.setState({ error: true, loading: false });
      });
  }

  redirectToLogin(){
    this.props.history.push('/login')
  }

  render() {
    return (
      <div className={style?.login}>
        <div className={style?.["form-wrapper"]}>
          <div className={style?.form}>
            <div className={style?.logo}>
              <Logo />
            </div>
            <div className={`${style?.["block"]} block`}>
              {this.state.loading ? (
                <Loader />
              ) : (
                <>
                  <h2>{i18n.t("RESET_PASSWORD_TITLE")}</h2>
                  {/* { this.state.error && <p>Email or password not recognized, please try again</p> } */}
                  <form onSubmit={this.reset}>
                    <div className={`${style?.field} field`}>
                      <label>{i18n.t("FIELD_EMAIL")}</label>
                      <input
                        type="email"
                        required
                        placeholder={i18n.t("FIELD_EMAIL_PLACEHOLDER")}
                        value={this.state.email}
                        onChange={(e) =>
                          this.setState({ email: e.target.value })
                        }
                      />
                      {this.state.resetSent && (
                        <div className={style['message']}>{i18n.t("RESET_EMAIL_SENT")}</div>
                      )}
                    </div>
                    <div className={style["btn-group"]}>
                      <button type='button' onClick={() => {
                        this.redirectToLogin()
                      }} className={style['reset']}>{i18n.t("RESET_TO_LOGIN")}</button>
                      <button className="blue">
                        {i18n.t("RESET_SEND")}
                      </button>
                    </div>
                  </form>
                </>
              )}
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default ResetPasswordRequest;
